import type {RawComponentExportStructure, ComponentWithResolvedDataItems} from '@wix/document-services-types'
import type {SingleComponentPluginFunction} from '../../types'

export const pack: SingleComponentPluginFunction = (component: ComponentWithResolvedDataItems): void => {
    const {structure, data, overrides} = component as RawComponentExportStructure

    delete component.structure
    delete component.data
    delete component.overrides

    Object.assign(component, structure, data)

    if (overrides) {
        component.overrides = overrides
    }
}
